import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeroSearchForm from "./HeroSearchForm"; 
import { AnimatePresence, motion } from "framer-motion"; 

// Tab configuration for Buy, Sell, Rent
const TABS = [
  { title: "Buy", key: "buy", content: <HeroSearchForm /> }, 
  { title: "Sell", key: "sell", content: <HeroSearchForm /> }, 
  { title: "Rent", key: "rent", content: <HeroSearchForm /> }, 
];

export default function HeroSection2() {
  const [activeTab, setActiveTab] = useState("buy"); // State to track the active tab

  return (
    <>
      <section className="hero-section hero-section-two" id="home2">
        <Container>
          <Row>
            <Col lg={10} xxl={8}>
              {/* Apply animation on the main content of the section */}
              <motion.div   
                whileInView={{ scale: 1 }} 
                initial={{ scale: 0.8 }} 
                transition={{
                  type: "linear", 
                  stiffness: 100, 
                  duration: 1, 
                }}
              >
                <div className="hero-section-main-content">
                  <div className="hero-section-content w-100 position-relative">
                    {/* Section for the hero text */}
                    <Row>
                      <Col lg={12} xl={10}>
                        <span className="hero-badge shadow-sm mb-3">A Vision for Your Life</span>
                        {/* Main title with a highlighted word "Real Estate" */}
                        <h1 className="hero-title display-3 fw-medium mb-0">
                          Find Your Ideal{" "}
                          <span className="text-primary">Real Estate</span> Now
                        </h1>
                        {/* Description paragraph */}
                        <p className="text-dark mt-4 pt-1 me-xl-4 mb-50">
                          Explore premium properties tailored to your needs, from stunning homes to lucrative investments. Start your journey with us and unlock the key to your dream real estate.
                        </p>
                      </Col>
                    </Row>
                    {/* Tab navigation */}
                    <Row>
                      <Col xl={12}>
                        <div className="position-relative mt-2">
                          <ul className="nav nav-tabs justify-content-center hero-tab-filter" role="tablist">
                            {/* Generate tabs dynamically */}
                            {TABS.map((tab) => (
                              <li className="nav-item" role="presentation" key={tab.key}>
                                <button
                                  className={`nav-link ${
                                    activeTab === tab.key ? "active" : ""
                                  }`}
                                  id={`${tab.key}-tab`}
                                  data-bs-toggle="tab"
                                  type="button"
                                  role="tab"
                                  onClick={() => setActiveTab(tab.key)}
                                >
                                  {tab.title} {/* Tab title */}
                                </button>
                              </li>
                            ))}
                          </ul>

                          {/* Tab content section */}
                          <div className="tab-content hero-tab-content">
                            <AnimatePresence mode="wait">
                              {/* Animate content based on the active tab */}
                              {TABS.map(
                                (tab) =>
                                  tab.key === activeTab && (
                                    <motion.div
                                      key={tab.key}
                                      className="tab-pane active"
                                      role="tabpanel"
                                      initial={{ opacity: 0, y: 20 }} 
                                      animate={{ opacity: 1, y: 0 }}
                                      exit={{ opacity: 0, y: -20 }}
                                      transition={{
                                        duration: 0.4, 
                                        ease: "easeInOut",
                                      }}
                                    >
                                      {tab.content} {/* Render the content of the active tab */}
                                    </motion.div>
                                  )
                              )}
                            </AnimatePresence>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
